import { Article, Campaign, Gavel } from "@mui/icons-material";
import { ListItemDecorator, TabList, Tabs } from "@mui/joy";
import { useMatchRoute } from "@tanstack/react-router";
import { useMemo } from "react";

import Warning from "@/assets/icons/Warning";
import { useQuestQuery } from "@/hooks/quests";
import { useCurrentVenueUuid } from "@/hooks/venues";

import { TabLink } from "../Links";
import getPublishWarnings, { useHideWarningsMap } from "./getPublishWarnings";

const PROFILE_PATH = "/gym/$venueUuid/loyalty/quests/$questUuid/profile";

const TABS = [
  { value: "details", label: "Details", icon: <Article />, to: `${PROFILE_PATH}/details` },
  { value: "rules", label: "Rules", icon: <Gavel />, to: `${PROFILE_PATH}/rules` },
  { value: "promotion", label: "Promotion", icon: <Campaign />, to: `${PROFILE_PATH}/promotion` },
] as const;

export default function QuestProfileTabs({ questUuid }: { questUuid: string | undefined }) {
  const venueUuid = useCurrentVenueUuid();
  const { data: quest } = useQuestQuery(questUuid, venueUuid);
  const publishWarnings = useMemo(() => getPublishWarnings(quest), [quest]);
  const hideWarningsMap = useHideWarningsMap(questUuid);
  const matchRoute = useMatchRoute();
  const activeTab = TABS.find(({ to }) => matchRoute({ to }))?.value ?? "details";
  return (
    <Tabs value={activeTab}>
      <TabList>
        {TABS.map(({ value, label, icon, to }) => (
          <TabLink
            key={value}
            value={value}
            sx={{ flex: 1, height: 40 }}
            from="/gym/$venueUuid/loyalty/quests/$questUuid"
            to={questUuid ? to : "/gym/$venueUuid/loyalty/quests/create"}
            search={questUuid ? undefined : true}
            disabled={!questUuid && value !== "details"}
            replace
          >
            <ListItemDecorator>
              {!hideWarningsMap[value] && publishWarnings.byTab[value] ? <Warning /> : icon}
            </ListItemDecorator>
            {label}
          </TabLink>
        ))}
      </TabList>
    </Tabs>
  );
}
